var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '../../common';
import { ExpandableRowLabel } from '../../common/tableHierarchy';
import { useCurrencySymbol } from '../../hooks/useCurrencyOptions';
import { QueueType } from '../../multiskill/types';
import { useResourcingContext } from '../../report/hooks';
import { DisplayMode } from '../../report/resourcing';
import { useDisplayModeParams } from '../../report/selectors';
import { PLAN_COLORS } from '../../wizard/constants';
import { FirstCell, STICKIES } from '../annualTable';
import { MultigeoLobRow } from '../common/multigeoQueuesByLob';
import { MultiskillGroupRows } from '../common/multiskillGroupRow';
import { useMultiskillGroupNames, useSelectQueuesByLobPerScenario } from '../common/selectors';
import { getChunkBaselineValue } from '../common/utils';
import { HIERARCHY_LEVEL, MULTISKILL_COLOR, NEST_LEVEL, TOTAL_ROW_COLOR } from '../constants';
import { generateVariances, useSelectCurrency, useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
export var StaffBudgetSection = function (_a) {
  var _b;
  var expandedProp = _a.expandedProp,
    onToggle = _a.onToggle,
    expandedItems = _a.expandedItems,
    onToggleItem = _a.onToggleItem;
  var t = useTranslation('report', {
    keyPrefix: 'annual.reportRows'
  }).t;
  var data = useSummaryByDisplayMode();
  var chunkSize = useSummaryChunkSize();
  var lobsPerScenario = useSelectQueuesByLobPerScenario();
  var currency = useSelectCurrency();
  var _c = useCurrencySymbol(currency),
    currencyPrefix = _c.prefix,
    currencySuffix = _c.suffix;
  var isPercentages = useResourcingContext().isPercentages;
  var displayMode = useDisplayModeParams()[0];
  var _d = useState(true),
    localExpanded = _d[0],
    setLocalExpanded = _d[1];
  var expanded = expandedItems ? (_b = expandedItems.totalBudgets) !== null && _b !== void 0 ? _b : false : expandedProp !== null && expandedProp !== void 0 ? expandedProp : localExpanded;
  var handleToggle = onToggleItem ? function () {
    return onToggleItem('totalBudgets');
  } : onToggle !== null && onToggle !== void 0 ? onToggle : function () {
    return setLocalExpanded(function (e) {
      return !e;
    });
  };
  var multiskillGroupNames = useMultiskillGroupNames(data !== null && data !== void 0 ? data : []);
  if (!data || !lobsPerScenario.length) return null;
  var totalPerScenario = data.map(function (s) {
    var _a;
    return (_a = s.totalBudgets) !== null && _a !== void 0 ? _a : null;
  });
  return _jsxs(_Fragment, {
    children: [_jsxs(TableRow, {
      children: [_jsx(FirstCell, __assign({
        "aria-label": NEST_LEVEL[HIERARCHY_LEVEL.total],
        stickySizes: STICKIES,
        bold: true,
        color: TOTAL_ROW_COLOR
      }, {
        children: _jsx(ExpandableRowLabel, __assign({
          expanded: expanded,
          onToggle: handleToggle,
          bold: true
        }, {
          children: t('totalBudgets')
        }))
      })), totalPerScenario.map(function (value, index, arr) {
        var _a, _b, _c;
        var baseValue = getChunkBaselineValue(totalPerScenario, index, chunkSize);
        var isMultiskillColumn = ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.dataType) === QueueType.Multiskill;
        return _jsx(TableCell, {
          colSpan: 2,
          value: value,
          decimal: 0,
          currency: currency,
          bold: true,
          color: isMultiskillColumn ? MULTISKILL_COLOR : (_c = PLAN_COLORS[(_b = data[index]) === null || _b === void 0 ? void 0 : _b.colorIndex]) === null || _c === void 0 ? void 0 : _c[1],
          highlightBorder: index + 1 !== arr.length && !((index + 1) % chunkSize),
          useColorValue: true,
          expandchildren: displayMode === DisplayMode.All ? undefined : generateVariances(baseValue !== null && baseValue !== void 0 ? baseValue : null, value, isPercentages, {
            decimalPlaces: 0,
            currencyPrefix: currencyPrefix,
            currencySuffix: currencySuffix
          })
        }, "total-budgets-".concat(index, "-").concat(arr.length));
      })]
    }), expanded && lobsPerScenario.map(function (lobEntry) {
      return _jsx(MultigeoLobRow, {
        lob: lobEntry.template,
        perScenarioLob: lobEntry.perScenarioLob,
        data: data,
        chunkSize: chunkSize,
        keyItem: "totalBudgets",
        hideConstraintHeader: true,
        expandedItems: expandedItems,
        onToggleItem: onToggleItem
      }, "staffBudget-".concat(lobEntry.lobName));
    }), expanded && _jsx(MultiskillGroupRows, {
      groupNames: multiskillGroupNames,
      data: data,
      chunkSize: chunkSize,
      valueKey: "totalBudgets",
      showVariance: true,
      expandedItems: expandedItems,
      onToggleItem: onToggleItem
    })]
  });
};